// FillyOnIris Constants
// Centralized configuration for agent IDs, field mappings, and UI constants

// DEPRECATED: Hardcoded agent IDs — now resolved from org/portfolio config via configResolver.ts
// Kept as empty fallback for backward compatibility. Actual defaults are in defaultAgentConfig.ts.
// export const AGENT_IDS = {
//   intake: 'b663f15e-7d9f-4812-bb84-a6f57998d71c',
//   finaljson: 'f01befd7-6ef0-441e-926b-0851e48b9951',
//   explore: 'c1a7e3b7-55c0-4cb8-88c1-568517e2a65d',
//   narrative: '950820e9-0d95-4330-8f47-888cd03fb776',
//   prioritize: 'eec5ab1f-deb7-4ef3-91ed-741193debbee'
// } as const;

// Re-export from defaultAgentConfig for backward compatibility
import { DEFAULT_AGENT_CONFIG } from './defaultAgentConfig';
export const AGENT_IDS = {
  intake: DEFAULT_AGENT_CONFIG.chat || '',
  finaljson: DEFAULT_AGENT_CONFIG.finaljson || '',
  explore: DEFAULT_AGENT_CONFIG.explore || '',
  narrative: DEFAULT_AGENT_CONFIG.narrative || '',
  prioritize: DEFAULT_AGENT_CONFIG.prioritize || '',
} as const;

 

export const INITIAL_MESSAGES = {
  intake: "👋 Hi there! I'm Filly, and  I'm here to help you submit a detailed feature request. Let's talk about what you'd like to improve or build. What's on your mind?",
  explore: "🔍 Welcome! I'm excited to help you explore solutions together. We'll work through your challenge step-by-step, understand what's working (and what's not), and discover the best path forward. What opportunity or challenge would you like to tackle?"
} as const;

export const EXPLORE_PHASES = {
  names: [
    "Problem Understanding",
    "Current State", 
    "Success Criteria",
    "Technical Context",
    "Solution Options",
    "Recommendation"
  ],
  icons: ["🎯", "📊", "✅", "⚙️", "💡", "🎉"],
  keys: ['problemUnderstanding', 'currentState', 'successCriteria', 'technicalContext', 'solutionOptions', 'recommendation']
} as const;

export const MODE_DESCRIPTIONS = {
  explore: "Let's explore your challenge and discover solutions together",
  intake: "Share your idea - I'll help capture all the important details"
} as const;

export const COMPLETION_SIGNALS = {
  intake: ["✅ All fields complete", "ready to summarize"],
  explore: ["Phase complete", "moving to next phase", "ready for next phase", "let's move to", "next phase"]
} as const;

export const DATA_EXTRACTION_KEYWORDS = {
  problem_statement: ["problem", "pain point", "challenge"],
  desired_outcome: ["outcome", "success"],
  business_impact: ["impact", "kpi", "metric"],
  stakeholders: ["stakeholder", "user"],
  urgency: ["urgent", "timeline", "why now"]
} as const;

export const LOADING_STATES = {
  IRIS_PROCESSING: 'Thinking this through...',
  SIMILAR_REQUESTS: 'Checking for related requests...',
  ASANA_SUBMISSION: 'Submitting your request...',
  ORGANIZATIONS: 'Loading your portfolios...',
  GENERATING_SUMMARY: 'Pulling everything together...'
} as const;

export const STAGES = {
  Intake: "intake",
  Summarization: "summarization", 
  Complete: "complete"
} as const;

export type AppMode = 'explore' | 'intake';
export type ExplorePhase = 1 | 2 | 3 | 4 | 5 | 6;
export type LoadingState = keyof typeof LOADING_STATES | null;
